import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "grid gap-8 grid-cols-1 sm:grid-cols-2"
}

import { computed, toRefs, watchEffect } from 'vue';
import { Account, AccountPresenter } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: Account,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);
const loading = computed(() => account.value.relatedAccounts.loading);

watchEffect(async () => {
  await account.value.relatedAccounts.load();
});

return (_ctx: any,_cache: any) => {
  const _component_account_card_related = _resolveComponent("account-card-related")!

  return (_unref(loading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading... "))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(account).relatedAccounts.all, (relatedAccount) => {
          return (_openBlock(), _createBlock(_component_account_card_related, {
            key: relatedAccount.relationshipKey,
            "related-account": relatedAccount
          }, null, 8, ["related-account"]))
        }), 128))
      ]))
}
}

})